import { BreadcrumbComponent } from './breadcrumb.component';
import { Input, Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-crumb-item',
  templateUrl: './crumb-item.component.html'
})
export class CrumbItemComponent {

  @Input() link?: string = null;
  @Input() name: string;

  constructor() { 

  }
}
